<nav class="side stack">
  <div class="brand">
    <a
      class="brand-hit nav-link"
      href="#about"
      [attr.aria-label]="'nav.brand_about_aria' | translate"
    ></a>
    <svg
      class="brand-arc"
      viewBox="0 0 160 110"
      width="140"
      height="110"
      aria-hidden="true"
    >
      <path id="brandArcPath" d="M 20 90 A 62 100 0 0 1 140 90" fill="none" />
      <text class="brand-arc-text">
        <textPath
          href="#brandArcPath"
          startOffset="50%"
          text-anchor="middle"
          letter-spacing="-1"
        >
          {{ "nav.brand_arc" | translate }}
        </textPath>
      </text>
    </svg>
    <h1>EE</h1>
  </div>
  <a
    class="nav-link"
    href="#why-me"
    [innerHTML]="'nav.why_me' | translate"
    (click)="onNav('why-me')"
  ></a>
  <a
    class="nav-link"
    href="#skills"
    [innerHTML]="'nav.skills' | translate"
    (click)="onNav('skills')"
  ></a>
  <a
    class="nav-link"
    href="#my-work"
    [innerHTML]="'nav.my_work' | translate"
    (click)="onNav('my-work')"
  ></a>
  <a class="nav-link" href="#contact" (click)="onNav('contact')">
    {{ "nav.contact" | translate }}
  </a>
  <button
    #burgerBtn
    class="burger-btn"
    type="button"
    (click)="toggleMenu()"
    aria-label="Menü öffnen"
  >
    <img
      class="burger-img burger-img-default"
      src="assets/img/icons/burger_menu/burgerMenu_open.svg"
      alt=""
    />
    <img
      class="burger-img burger-img-hover"
      src="assets/img/icons/burger_menu/burgerMenu_open_hover.svg"
      alt=""
    />
  </button>
</nav>

<nav class="mobile-menu" *ngIf="isMenuOpen" #mobileMenu>
  <button
    class="mobile-menu__close"
    type="button"
    (click)="closeMenu()"
    aria-label="Menü schließen"
  >
    <img
      class="burger-img burger-img-default"
      src="assets/img/icons/burger_menu/burgerMenu_close.svg"
      alt=""
    />
    <img
      class="burger-img burger-img-hover"
      src="assets/img/icons/burger_menu/burgerMenu_close_hover.svg"
      alt=""
    />
  </button>
  <a
    class="mobile-menu__link"
    href="#why-me"
    (click)="onNav('why-me')"
    [innerHTML]="'nav.why_me' | translate"
  ></a>
  <a
    class="mobile-menu__link"
    href="#skills"
    (click)="onNav('skills')"
    [innerHTML]="'nav.skills_mobile' | translate"
  ></a>
  <a
    class="mobile-menu__link"
    href="#my-work"
    (click)="onNav('my-work')"
    [innerHTML]="'nav.my_work' | translate"
  ></a>
  <a
    class="mobile-menu__link"
    href="#contact"
    (click)="onNav('contact')"
    [innerHTML]="'nav.contact_mobile' | translate"
  >
  </a>
  <div class="mobile-menu__langs">
    <a
      class="de"
      href="/de"
      lang="de"
      hreflang="de"
      (click)="setGerman(); $event.preventDefault()"
      >DE</a
    >
    <a
      class="en"
      href="/en"
      lang="en"
      hreflang="en"
      (click)="setEnglish(); $event.preventDefault()"
      >EN</a
    >
  </div>
</nav>
